var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-dialog', {
    attrs: {
      "title": "Edit Service Type",
      "close-on-click-modal": false,
      "visible": _vm.visible,
      "width": "1100px",
      "top": "3vh"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      }
    }
  }, [_c('div', {
    staticClass: "tableBorder"
  }, [_c('el-form', {
    ref: "dataForm",
    attrs: {
      "model": _vm.dataForm,
      "autocomplete": "off",
      "label-position": "top"
    }
  }, [_c('el-row', {
    staticClass: "customTh",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    staticClass: "tac",
    attrs: {
      "span": 4
    }
  }, [_vm._v("Service Type")]), _c('el-col', {
    staticClass: "tac",
    attrs: {
      "span": 9
    }
  }, [_vm._v("Service Details")]), _c('el-col', {
    staticClass: "tac",
    attrs: {
      "span": 3
    }
  }, [_vm._v("Currency")]), _c('el-col', {
    staticClass: "tac",
    attrs: {
      "span": 4
    }
  }, [_vm._v("Related Transaction")]), _c('el-col', {
    staticClass: "tac",
    attrs: {
      "span": 4
    }
  }, [_vm._v("Related Turnover")])], 1), _vm._l(_vm.dataForm.serviceList, function (item, index) {
    return _c('div', {
      key: "serviceList".concat(index),
      staticClass: "customTbody"
    }, [_c('el-row', {
      attrs: {
        "gutter": 10
      }
    }, [_c('el-col', {
      staticClass: "tac",
      attrs: {
        "span": 4
      }
    }, [_c('el-form-item', [_vm._v(_vm._s(item.serviceType))])], 1), _c('el-col', {
      staticClass: "tac",
      attrs: {
        "span": 9
      }
    }, [_c('el-form-item', [_c('span', {
      staticClass: "enbr"
    }, [_vm._v(_vm._s(item.serviceDetails.filter(function (item) {
      return item;
    }).join(", ")))])])], 1), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-form-item', {
      ref: "serviceList.".concat(index, ".currency"),
      refInFor: true,
      attrs: {
        "prop": "serviceList.".concat(index, ".currency")
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": "Currency",
        "clearable": "",
        "filterable": ""
      },
      model: {
        value: _vm.dataForm.serviceList[index].currency,
        callback: function callback($$v) {
          _vm.$set(_vm.dataForm.serviceList[index], "currency", $$v);
        },
        expression: "dataForm.serviceList[index].currency"
      }
    }, _vm._l(_vm.currencyList, function (item, idx) {
      return _c('el-option', {
        key: "currency-".concat(index, "-").concat(idx),
        attrs: {
          "label": item.currency,
          "value": item.currency
        }
      });
    }), 1)], 1)], 1), _c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('el-form-item', {
      ref: "serviceList.".concat(index, ".relatedTransaction"),
      refInFor: true,
      attrs: {
        "prop": "serviceList.".concat(index, ".relatedTransaction")
      }
    }, [_c('el-input', {
      directives: [{
        name: "minusPoint2",
        rawName: "v-minusPoint2"
      }],
      attrs: {
        "clearable": "",
        "placeholder": "0.00"
      },
      model: {
        value: _vm.dataForm.serviceList[index].relatedTransaction,
        callback: function callback($$v) {
          _vm.$set(_vm.dataForm.serviceList[index], "relatedTransaction", $$v);
        },
        expression: "dataForm.serviceList[index].relatedTransaction"
      }
    }, [_c('template', {
      slot: "prefix"
    }, [_vm._v(_vm._s(_vm.currencySymbolFormat(_vm.dataForm.serviceList[index].currency)))])], 2)], 1)], 1), _c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('el-form-item', {
      ref: "serviceList.".concat(index, ".relatedTurnover"),
      refInFor: true,
      attrs: {
        "prop": "serviceList.".concat(index, ".relatedTurnover")
      }
    }, [_c('el-input', {
      directives: [{
        name: "minusPoint2",
        rawName: "v-minusPoint2"
      }],
      attrs: {
        "clearable": "",
        "placeholder": "0.00"
      },
      model: {
        value: _vm.dataForm.serviceList[index].relatedTurnover,
        callback: function callback($$v) {
          _vm.$set(_vm.dataForm.serviceList[index], "relatedTurnover", $$v);
        },
        expression: "dataForm.serviceList[index].relatedTurnover"
      }
    }, [_c('template', {
      slot: "prefix"
    }, [_vm._v(_vm._s(_vm.currencySymbolFormat(_vm.dataForm.serviceList[index].currency)))])], 2)], 1)], 1)], 1)], 1);
  })], 2)], 1), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function click($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v("Cancel")]), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.dataFormSubmit
    }
  }, [_vm._v("OK")])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }